

const MMPLDashboardReducer = (state = {}, action) => {
    switch (action.type) {
        case "GetMMPLShipCountSuccess":
            return Object.assign({}, state, {
                MMPLShipCount: action.data,
            });
            break;
        case "GetMMPLShipCountFailure":
            return Object.assign({}, state, {
                MMPLShipCount: action.data,
            });
            break;
        case "GetMMPLShipDetailSuccess":
            return Object.assign({}, state, {
                MMPLShipDetail: action.data,
            });
            break;
        case "GetMMPLShipDetailFailure":
            return Object.assign({}, state, {
                MMPLShipDetail: action.data,
            });
            break;
            case "GetMMPLHistorySearchSuccess":
                return Object.assign({}, state, {
                    MMPLHistorySearchResult: action.data,
                });
                break;
            case "GetMMPLHistorySearchFailure":
                return Object.assign({}, state, {
                    MMPLHistorySearchResult: action.data,
                });
                break;
           
        case "GetMMPLSearchSuccess":
            return Object.assign({}, state, {
                MMPLShipSearchResult: action.data,
            });
            break;
            case "GetMMPLPendingSearchSuccess":
                return Object.assign({}, state, {
                    MMPLPendingShipSearchResult: action.data,
                });
                break;
        case "GetMMPLSearchFailure":
            return Object.assign({}, state, {
                MMPLShipSearchResult: action.data,
            });
            break;
        case "GetMMPLShipInfoSuccess":
            return Object.assign({}, state, {
                MMPLShipInfo: action.data,
            });
            break;
        case "GetMMPLShipInfoFailure":
            return Object.assign({}, state, {
                MMPLShipInfo: action.data,
            });
            break;
        case "GetMMPLShipDetailSuccess":
            return Object.assign({}, state, {
                MMPLShipDetail: action.data,
            });
            break;
        case "GetMMPLShipDetailFailure":
            return Object.assign({}, state, {
                MMPLShipDetail: action.data,
            });
            break;
        case "GetMMPLShipHistorySuccess":
            return Object.assign({}, state, {
                MMPLShipHistory: action.data,
            });
            break;
        case "GetMMPLShipHistoryFailure":
            return Object.assign({}, state, {
                MMPLShipHistory: action.data,
            });
            break;
        default: {
            return state;
        }
    }
};
export default MMPLDashboardReducer;
